import React from "react";
import { Row, Col, Card } from "react-bootstrap";

export const ReportKpiCards = ({ totals, role }) => {
  if (!totals) return null;

  const cards = [
    {
      title: "Total Volume",
      value: `₹${(totals.total_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      sub: `${totals.total_txn || 0} Total Txns`,
      bgClass: "bg-primary text-white",
    },
    {
      title: "Success Amount",
      value: `₹${(totals.success_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      sub: `${totals.success_count || 0} Successful`,
      bgClass: "bg-success text-white",
    },
    {
      title: role === "Main Admin" ? "Platform Earnings" : "My Commission",
      value: `₹${(totals.commission || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      sub: `TDS: ₹${totals.tds || 0} | Charges: ₹${totals.charge || 0}`,
      bgClass: "bg-info text-white",
    },
    {
      title: "Failed / Pending",
      value: `${totals.failed_count || 0} Failed`,
      sub: `${totals.pending_count || 0} In Progress`,
      bgClass: "bg-danger text-white",
    },
  ];

  return (
    <Row className="g-3 mb-4">
      {cards.map((c, i) => (
        <Col xs={12} sm={6} lg={3} key={i}>
          <Card className={`border-0 shadow-sm h-100 ${c.bgClass}`}>
            <Card.Body className="d-flex flex-column justify-content-between p-4">
              <div className="small fw-semibold text-uppercase opacity-75 mb-2">{c.title}</div>
              <h3 className="fw-bold mb-1 fs-4">{c.value}</h3>
              <div className="small opacity-75">{c.sub}</div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
